import styled, { ThemeProvider } from 'styled-components';
import Label from 'components/atoms/Label';
import Input from 'components/atoms/Input';
import icons from 'globalConstants/Icons';
import Bubble from 'components/atoms/Bubble';
import IconSprite from 'components/atoms/IconSprite';
import { iconThemes } from 'globalConstants/Themes';

const Button = (props) => {
  const hasIcon = (props?.useIcon ?? true) && props?.name in icons;
  const editable = props.editable;
  const label = props.label && props.label.toString().replace('_', ' ');
  const bubble = props.bubble ?? '';
  const vertical = props.theme?.vertical ?? false;
  const upperCase = props.theme?.uppercase ?? false

  return (
    <ThemeProvider theme={props.theme || {}}>
      <Button.Wrapper id={props.id} className={props.className} state={iconThemes[props.state]} editable={editable}
        onClick={props.onClick} onMouseDown={props.onMouseDown} onMouseUp={props.onMouseUp} // for info
        data-tooltip-id={props.name} data-tooltip-content={bubble} data-tooltip-place={props.place || 'top'}
        data-bs-target={props.target} data-bs-slide-to={props.slideTo} data-bs-slide={props.slide}>
        <Input type={props.type || 'button'} name={props.name} />
        <Label htmlFor={props.name} type={props.type || 'button'} hasIcon={hasIcon} label={props.label} editable={editable}>
          {props.label && editable && <span className={'align-items-center text-truncate'} >{label}</span>}
          {hasIcon && <IconSprite state={props.state} icon={props.name} size={props.theme?.iconSize || '34px'} scale={props.theme?.iconScale || '1'} usage={props.usage} />}
          {props.label && !editable && <span className={`
          d-inline-flex align-items-center 
          ${hasIcon ? `w-100 ms-${vertical ? '0 justify-content-center' : '2'} ` : 'juistify-content-center'}
          ${upperCase ? 'text-uppercase' : ''}`} >{label}</span>}
        </Label>
      </Button.Wrapper>
      {props.bubble && <Bubble id={props.name} className={'button-tooltip'}/>}
    </ThemeProvider>
  )
};

export default Button;

Button.Wrapper = styled.div.attrs(props => {
  return ({
    id: `${props.id ?? ''}`,
    className: `d-flex align-items-center `,
  })
})`
  background-color: ${props => props.state?.background || props.theme.background};
  color: ${props => props.state?.color || props.theme.color};
  font-weight: bold;
  font-size: ${props => props.theme.size};
  border: ${props => props.state?.border || props.theme.border};
  border-right: ${props => props.theme.borderRight};
  border-radius: ${props => props.theme.radius};
  height: ${props => props.theme.maxHeight || '100%'};
  min-height: ${props => props.theme.maxHeight || '30px'};
  width: ${props => props.theme.width};
  padding: ${props => props.theme.padding};
  max-width: ${props => props.theme.maxWidth};
  justify-content: ${props => props.theme.justify || (props.editable ? 'start' : 'center')};
  :hover {
    max-width: ${props => props.editable && 'fit-content'};
  };
  :hover .text-truncate {
    overflow: visible;
    text-overflow: unset;
    white-space: unset;
  }
  `;
